/* eslint-disable */
import { httpPostObservable } from './utils';

const api = {
  createCareTeam: (url, params) => httpPostObservable(url, params),
  fetchCareTeamList: (url, params) => httpPostObservable(url, params)
};

export default api;
